import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Tabs, Input } from 'antd';
import { areatype, isunfold, areastatus, associatedTabLayout } from '../utilService';
import { updateAreaList, updateSelectArea } from 'Store/ZoneSetting/action';
import { langCheck } from 'Pub/js/utils';
import { ControlTip } from 'Components/ControlTip';
import MdDefaultClassEntityRef from 'Components/Refers/mdDefaultClassEntityRef';
import platform from 'Pub/js/platform';
import Notice from "Components/Notice";
const { toast } = platform;
const { NCSelect, NCRadio, NCDiv, NCCheckbox, NCMultiLangText, NCFormControl } = platform.base;
import { setActiveTabKey, checkAreaType } from '../events';
const Option = NCSelect.NCOption;
const TabPane = Tabs.TabPane;
const RadioGroup = NCRadio.NCRadioGroup;
let formItemStyle = { height: 28, width: '100%' };
class SetTemplateRight extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    // 获取关联区域编码
    relationcode = () => {
        let { areaList, selectedArea } = this.props;
        let relationArea = _.cloneDeep(areaList);
        //表格
        if (selectedArea.areatype === '2') {
            relationArea = relationArea.filter(
                item => item.areatype === '2' && !item.associatedtab,
            );
        }
        let result = relationArea.map(item => ({ name: item.code, value: item.code }));
        result = result.filter(item => item.value !== '');
        //加一个空编码用于解除关联
        return [{ name: '', value: '' }].concat(result);
    };

    //获取多页签关联区域编码
    getAssociatedtabCode = () => {
        let { areaList, selectedArea } = this.props;
        let relationArea = _.cloneDeep(areaList);
        //表格
        if (selectedArea.areatype === '2') {
            relationArea = relationArea.filter(item => {
                if (item.areatype === '2' && item.code !== selectedArea.code && !item.associatedtab) {
                    if (selectedArea.isgrandson) { //孙表只能关联到孙表
                        return item.isgrandson;
                    } else {
                        return !item.isgrandson;
                    }
                }
            });
        } else if (selectedArea.areatype === '1') { //表单
            relationArea = relationArea.filter(
                item =>
                    item.areatype === '1' &&
                    item.code !== selectedArea.code &&
                    item.code === item.headcode,
            );
        }
        let result = relationArea.map(item => ({ name: item.code, value: item.code }));
        //加一个空编码用于解除关联
        return [{ name: '', value: '' }].concat(result);
    }

    // //获取多页签主表编码
    // getTabHeadCode = () => {
    //     const tabHeadArea = this.props.areaList.filter(item => item.areatype === '2');
    //     let result = tabHeadArea.map(item => ({ name: item.code, value: item.code }));
    //     //加一个空编码用于解除关联
    //     return [{ name: '', value: '' }].concat(result);
    // };

    /**
     * 按回车键，input失去焦点
     * @param {String} value 设置的value值
     * @param {String} propertyKey 属性主键
     */
    onPressEnter = (value, property) => {
        this[`${property}input`].blur();
    };
    autoCheckPageSizeValue = value => {
        let { json } = this.props;
        if (value === '' || value === undefined) {
            // value = '100';
            Notice({
                status: "warning",
                msg: langCheck('ZoneSetting-000353', 'pages', json),
            });
            return value;
        }
        // 新加的pagesize字段要判断是否查出边界
        // 大于5000，需要回归5000，并给出提示，
        // 小于1，需要回归1，并给出提示
        if (parseFloat(value) > 5000) {
            value = '5000';
            Notice({
                status: "warning",
                msg: langCheck('ZoneSetting-000354', 'pages', json),
            });
        }
        if (parseFloat(value) < 1) {
            value = '1';
            Notice({
                status: "warning",
                msg: langCheck('ZoneSetting-000354', 'pages', json),
            });
        }
        // 不是整数，给出提示
        if (!_.isInteger(parseFloat(value))) {
            value = '100';
            Notice({
                status: "warning",
                msg: langCheck('ZoneSetting-000354', 'pages', json),
            });
        }

        return value;
    }
    /**
     * input数据变化，更新redux中selectedArea/areaList对象
     * @param {String} value 设置的value值
     * @param {String} propertyKey 属性主键
     */
    changeTemplateValue = (value, propertyKey) => {
        let { selectedArea, areaList, json } = this.props;
        let lastAssociatedtab = selectedArea.associatedtab;
        areaList = _.cloneDeep(areaList);
        if (_.isEmpty(selectedArea)) {
            return;
        }
        let oldValue = _.cloneDeep(selectedArea);
        selectedArea = { ...selectedArea };
        if (propertyKey === 'metaObj') {
            let currAreaIndex = areaList.findIndex(item => item.pk_area === selectedArea.pk_area); //当前选中区域index
            if (!_.isEmpty(areaList[currAreaIndex].queryPropertyList)) {
                //有字段再给提示
                ControlTip({
                    status: 'warning',
                    title: langCheck('102202APP-000021', 'pages', json) /* 国际化处理： 确认*/,
                    msg: langCheck(
                        '102202APP-000071',
                        'pages',
                        json,
                    ) /* 国际化处理： 修改或清空该字段后,会清空该区域已配置的元数据*/,
                    onOk: () => {
                        setMetaData.call(this);
                    },
                    onCancel: () => {
                        selectedArea['metaname'] = oldValue.metaname;
                        selectedArea['metaid'] = 'root';
                        selectedArea['refcode'] = oldValue.refcode;
                        this.props.updateSelectArea(selectedArea); //更新选中区域
                    },
                });
                return;
            }
            setMetaData.call(this);
        } else {
            //多页签关联区域与多页签主表联动
            if (propertyKey === 'associatedtab') {
                setAssociatedRelationItem(selectedArea, value);
                if (value !== '' && selectedArea.areatype === '2') {
                    //切换多页签关联区域后移动区域位置，目的是保证区域顺序与页签顺序一致
                    areaList = this.getMoveAreaList(selectedArea, this.props.areaList.find(item => item.code === value));
                }
            }
            if (selectedArea.areatype === '2' && propertyKey === 'pagesize') {
                value = this.autoCheckPageSizeValue(value);
            }
            selectedArea[propertyKey] = value;
            areaList.map(item => {
                if (item.pk_area == selectedArea.pk_area) {
                    item[propertyKey] = value;
                    //多页签关联区域与多页签主表联动
                    if (propertyKey === 'associatedtab') {
                        setAssociatedRelationItem(item, value);
                    }
                }
            });
            this.props.updateSelectArea(selectedArea); //更新选中区域
            this.props.updateAreaList(areaList); //更新整个数组
            if (propertyKey === 'associatedtab') {
                if (!value) {
                    setActiveTabKey({
                        areaCode: lastAssociatedtab,
                        activeKey: lastAssociatedtab,
                        expand: false,
                    });
                    setActiveTabKey({
                        areaCode: selectedArea.code,
                        activeKey: selectedArea.code,
                        expand: true,
                    });
                } else {
                    setActiveTabKey({
                        areaCode: value,
                        activeKey: selectedArea.code,
                        expand: true,
                    });
                }
            }
        }

        //设置元数据
        function setMetaData() {
            selectedArea['metaname'] = value.refname;
            selectedArea['metaid'] = value.refpk;
            selectedArea['refcode'] = value.refcode;
            selectedArea['queryPropertyList'] = [];
            selectedArea['formPropertyList'] = [];
            areaList.map(item => {
                if (item.pk_area == selectedArea.pk_area) {
                    item['metaname'] = value.refname;
                    item['metaid'] = value.refpk;
                    item['refcode'] = value.refcode;
                    item['queryPropertyList'] = [];
                    item['formPropertyList'] = [];
                }
            });
            this.props.updateSelectArea(selectedArea); //更新选中区域
            this.props.updateAreaList(areaList); //更新整个数组
        }

        //切换多页签关联区域设置联动字段
        function setAssociatedRelationItem(area, value) {
            if (value !== '') {
                //子表多页签关联区域默认给多页签主表赋值
                if (area.areatype === '2') {
                    area['tabheadcode'] = value;
                }
                //设置主表多页签关联区域清空关联区域编码
                if (area.areatype === '1') {
                    area['relationcode'] = '';
                }
            }
        }
    };

    //获取移动区域顺序 selectedArea:当前区域 targetArea：目标区域
    getMoveAreaList = (selectedArea, targetArea) => {
        if (!targetArea) { return; }
        let areaList = _.cloneDeep(this.props.areaList);
        const selectedIndex = areaList.findIndex(item => item.pk_area === selectedArea.pk_area);
        const targetIndex = areaList.findIndex(item => item.pk_area === targetArea.pk_area);
        //选中区域在目标区域前面移动区域到目标区域后面
        if (selectedIndex < targetIndex) {
            areaList.splice(selectedIndex, 1);
            areaList.splice(targetIndex + 1, 0, selectedArea);
        }
        return areaList;
    }
    /**
     * 云融合阶段，新设计器无法发布，所以根据玉洁需求将新设计器中多语文本配置移植到旧版设计器中
     * 多语文本组件值改变事件
     * @param {Object} value 多语文本值
     * @param {String} propertyKey 属性字段名
     * @returns
     */
    changeMultiLangText = (value, propertyKey) => {
        let { selectedArea, areaList, json, multiOptions } = this.props;
        let k;
        // areaList = _.cloneDeep(areaList);
        if (_.isEmpty(selectedArea)) {
            return;
        }
        selectedArea = _.cloneDeep(selectedArea);
        for (let i = 0; i < multiOptions.length; i++) {
            k = `${propertyKey}${multiOptions[i].index}`;
            selectedArea[k] = value[k].value;
        }
        areaList = areaList.map(item => {
            if (item.pk_area === selectedArea.pk_area) {
                for (let i = 0; i < multiOptions.length; i++) {
                    k = `${propertyKey}${multiOptions[i].index}`;
                    item[k] = value[k].value;
                }
            }
            return item;
        });
        this.props.updateSelectArea(selectedArea);
        this.props.updateAreaList(areaList);

    }
    /**
     * 云融合阶段，新设计器无法发布，所以根据玉洁需求将新设计器中多语文本配置移植到旧版设计器中
     * 渲染多语文本字段
     * @param {String} placeholder 占位文字
     * @param {String} property 属性字段名
     * @returns
     */
    getMultiLangInput(placeholder, property) {
        let inputStyle = formItemStyle;
        let { areaList, selectedArea, validate, multiOptions } = this.props;
        let areaIndex = areaList.findIndex(item => item.pk_area === selectedArea.pk_area);
        let curArea = areaList[areaIndex];
        if (
            validate === false &&
            curArea &&
            property === 'name' &&
            curArea[property] === ''
        ) {
            inputStyle = { ...formItemStyle, ...{ borderColor: '#f5222d' } };
        }
        let itemValue = {};
        for (let i = 0; i < multiOptions.length; i++) {
            let k = `${property}${multiOptions[i].index}`;
            if (curArea) {
                itemValue[k] = { value: curArea[k] };
            }
        }
        return (
            <div fieldid={property}>
                <NCMultiLangText
                    style={inputStyle}
                    // value={this.props.selectedArea[property]}
                    value={itemValue}
                    onChange={value => {
                        this.changeMultiLangText(value, property);
                    }}
                    onBlur={value => {
                        this.changeMultiLangText(value, property);
                    }}
                    ref={input => (this[`${property}input`] = input)}
                    disabled={this.getItemDisabled(property)}
                    fieldid={property}
                    languageMeta={multiOptions}
                    attrcode={property}
                    isCheckChinese
                    maxlength={200}
                />
            </div>
        );
    }
    /**
     * 获得一个文本输入框组件（列表区-区域属性）
     * @param {String} placeholder 文本显示值
     * @param {String} property 属性主键
     * @return {} 文本输入框组件
     */
    getTemplateInput = (placeholder, property, maxlength) => {
        let inputStyle = formItemStyle;
        const { areaList, selectedArea, validate } = this.props;
        const areaIndex = areaList.findIndex(item => item.pk_area === selectedArea.pk_area);
        const curArea = areaList[areaIndex];
        if (
            validate === false &&
            curArea &&
            ['code', 'name'].includes(property) &&
            curArea[property] === ''
        ) {
            inputStyle = { ...formItemStyle, ...{ borderColor: '#f5222d' } };
        }
        return (
            <div fieldid={property}>
                <NCFormControl
                    style={inputStyle}
                    value={this.props.selectedArea[property]}
                    onChange={e => {
                        this.changeTemplateValue(e, property);
                    }}
                    onBlur={e => {
                        this.changeTemplateValue(e, property);
                    }}
                    ref={input => (this[`${property}input`] = input)}
                    onPressEnter={e => {
                        this.onPressEnter(e, property);
                    }}
                    disabled={this.getItemDisabled(property)}
                    maxlength={maxlength}
                    isCheckChinese
                />
                {/* <Input
                    style={inputStyle}
                    value={this.props.selectedArea[property]}
                    onChange={e => {
                        this.changeTemplateValue(e.target.value, property);
                    }}
                    onBlur={e => {
                        this.changeTemplateValue(e.target.value, property);
                    }}
                    ref={input => (this[`${property}input`] = input)}
                    onPressEnter={e => {
                        this.onPressEnter(e.target.value, property);
                    }}
                    disabled={this.getItemDisabled(property)}
                /> */}
            </div>
        );
    };
    /**
     * 获得一个下拉组件（列表区-区域属性）
     * @param {String} mySelectObj option
     * @param {String} property 属性主键
     * @return {} 文本输入框组件
     */
    getTemplateSelect = (mySelectObj, property) => {
        return (
            <div fieldid={property}>
                <NCSelect
                    showSearch
                    showClear={false}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    value={this.props.selectedArea[property]}
                    onChange={value => {
                        this.changeTemplateValue(value, property);
                    }}
                    // style={formItemStyle}
                    disabled={this.getItemDisabled(property)}
                    fieldid={property}
                >
                    {(() => {
                        return (
                            mySelectObj &&
                            mySelectObj.map((c, index) => {
                                return (
                                    <Option key={index} value={c.value}>
                                        {c.name}
                                    </Option>
                                );
                            })
                        );
                    })()}
                </NCSelect>
            </div>
        );
    };
    /**
     * 获得一个参照组件（列表区-区域属性）
     * @param {String} placeholder 文本显示值
     * @return {} 文本输入框组件
     */
    getTemplateRefer = placeholder => {
        let { selectedArea } = this.props;
        let initialValue = {
            refcode: selectedArea ? selectedArea.refcode : '',
            refname: selectedArea ? selectedArea.metaname : '',
            refpk: selectedArea ? selectedArea.metaid : '',
        };
        return (
            <MdDefaultClassEntityRef
                value={initialValue}
                onChange={value => {
                    if (value.refpk && !value.isEntity) {
                        toast({
                            color: "warning",
                            content: langCheck('102202APP-000082', 'pages', this.props.json)
                        });
                        this.changeTemplateValue({}, 'metaObj');
                        return;
                    }
                    this.changeTemplateValue(value, 'metaObj');
                }}
                disabled={this.props.isImplement} //实施态不能编辑
                fieldid="mdDefaultClassEntity"
            />
        );
    };
    /**
     * 获得一个单选组件（列表区-区域属性）
     * @param {String} mySelectObj option
     * @param {String} property 属性主键
     * @return {} 文本输入框组件
     */
    getTemplateRadio = (mySelectObj, property) => {
        const radioValue = this.props.selectedArea[property]
            ? this.props.selectedArea[property]
            : false;
        return (
            <div fieldid={property}>
                <RadioGroup
                    defaultValue={radioValue}
                    selectedValue={radioValue}
                    onChange={val => {
                        this.changeTemplateValue(val, property);
                    }}
                    style={formItemStyle}
                >
                    <NCRadio value={true} disabled={this.getItemDisabled(property)}>
                        {langCheck('102202APP-000069', 'pages', this.props.json)}
                    </NCRadio>
                    <NCRadio value={false} disabled={this.getItemDisabled(property)}>
                        {langCheck('102202APP-000070', 'pages', this.props.json)}
                    </NCRadio>
                </RadioGroup>
            </div>
        );
    };

    /**
     * 获得一个单选组件（列表区-区域属性）
     * @param {String} mySelectObj option
     * @param {String} property 属性主键
     * @return {} 单选组件
     *  */
    getTemplateCheckbox = (mySelectObj, property) => {
        return (
            <div fieldid={property}>
                <NCCheckbox
                    checked={
                        this.props.selectedArea[property]
                            ? this.props.selectedArea[property]
                            : false
                    }
                    onChange={value => {
                        console.log(this.props);
                        this.changeTemplateValue(value, property);
                    }}
                />
            </div>
        );
    };
    //判断字段是否禁用
    getItemDisabled = key => {
        const enableItems = ['name', 'isunfold', 'isclosequickquery', 'pagesize']; //实施态可以编辑的字段
        return this.props.isImplement && !enableItems.includes(key);
    };

    //渲染多页签字段
    renderTabFields = () => {
        const { selectedArea, json } = this.props;
        // 表格区有关联区域编码不显示多页签字段
        if (checkAreaType.isTable(selectedArea) && selectedArea.isgrandson !== true && selectedArea.relationcode && selectedArea.relationcode !== selectedArea.code) { return null; }
        return (
            <React.Fragment>
                {/* 表格多页签和主表表单多页签 */}
                {selectedArea.areatype &&
                    selectedArea.areatype !== '0' && (
                        <React.Fragment>
                            {/* 国际化处理： 多页签关联区域*/}
                            <li>{langCheck('102202APP-000074', 'pages', json)}</li>
                            <li>{this.getTemplateSelect(this.getAssociatedtabCode(), 'associatedtab')}</li>
                        </React.Fragment>
                    )}
                {/* {selectedArea.areatype &&
                    selectedArea.areatype == '2' &&
                    !selectedArea.associatedtab && (
                        <React.Fragment>
                            //多页签布局方式
                            <li>{langCheck('102202APP-000075', 'pages', json)}</li>
                            <li>
                                {this.getTemplateSelect(
                                    associatedTabLayout(json),
                                    'associatedtablayout'
                                )}
                            </li>
                        </React.Fragment>
                    )} */}
                {selectedArea.areatype && selectedArea.areatype == '2' && (
                    <React.Fragment>
                        {/* 国际化处理： 多页签主表*/}
                        <li>{langCheck('102202APP-000079', 'pages', json)}</li>
                        <li>{this.getTemplateSelect(this.getAssociatedtabCode(), 'tabheadcode')}</li>
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    };
    render() {
        let { json, selectedArea } = this.props;
        return (
            <Tabs
                defaultActiveKey="1"
                renderTabBar={(props, DefaultTabBar) => (
                    <NCDiv areaCode={NCDiv.config.TABS}>
                        {' '}
                        {/* 自动化测试标记 */}
                        <DefaultTabBar {...props} />
                    </NCDiv>
                )}
            >
                <TabPane tab={langCheck('102202APP-000067', 'pages', json)} key="1">
                    <ul className="basic-property rightTemplate">
                        <li className="required">{langCheck('102202APP-000038', 'pages', json)}</li>
                        {/* /* 国际化处理： 区域编码*/}
                        <li>
                            {this.getTemplateInput(
                                langCheck('102202APP-000038', 'pages', json),
                                'code',
                                50
                            )}
                        </li>
                        <li className="required">{langCheck('102202APP-000039', 'pages', json)}</li>
                        {/* /* 国际化处理： 区域名称*/}
                        {/* <li>
                            {this.getTemplateInput(
                                langCheck('102202APP-000039', 'pages', json),
                                'name'
                            )}
                        </li> */}
                        {/* /* 国际化处理： 区域名称*/}
                        {/* 云融合阶段，新设计器无法发布，所以根据玉洁需求将新设计器中多语文本配置移植到旧版设计器中 */}
                        <li>
                            {
                                this.getMultiLangInput(
                                    langCheck('102202APP-000039', 'pages', json),
                                    'name',
                                )
                            }
                        </li>
                        <li>{langCheck('102202APP-000040', 'pages', json)}</li>
                        {/* /* 国际化处理： 区域类型*/}
                        <li>{this.getTemplateSelect(areatype(json), 'areatype')}</li>
                        <li>{langCheck('102202APP-000064', 'pages', json)}</li>
                        {/* /* 国际化处理： 展开/收起*/}
                        <li>{this.getTemplateSelect(isunfold(json), 'isunfold')}</li>
                        <li>{langCheck('102202APP-000041', 'pages', json)}</li>
                        {/* /* 国际化处理： 区域描述*/}
                        <li>
                            {this.getTemplateInput(
                                langCheck('102202APP-000041', 'pages', json),
                                'areadesc',
                                200
                            )}
                        </li>
                        <li>{langCheck('102202APP-000042', 'pages', json)}</li>
                        {/* /* 国际化处理： 关联区域编码*/}
                        <li>{this.getTemplateSelect(this.relationcode(), 'relationcode')}</li>
                        <li>{langCheck('102202APP-000043', 'pages', json)}</li>
                        {/* /* 国际化处理： 设置类*/}
                        <li>
                            {this.getTemplateInput(
                                langCheck('102202APP-000043', 'pages', json),
                                'clazz',
                                200
                            )}
                        </li>
                        <li>{langCheck('102202APP-000044', 'pages', json)}</li>
                        {/* /* 国际化处理： 区域状态*/}
                        <li>{this.getTemplateSelect(areastatus(json), 'areastatus')}</li>
                        <li>{langCheck('102202APP-000036', 'pages', json)}</li>
                        {/* /* 国际化处理： 关联元数据*/}
                        <li>
                            <div fieldid="mdDefaultClassEntity">
                                {this.getTemplateRefer(
                                    langCheck('102202APP-000036', 'pages', json),
                                )}
                            </div>
                        </li>
                        {selectedArea.areatype && selectedArea.areatype == '2' && (
                            <React.Fragment>
                                {/* /* 国际化处理： 是否孙表*/}
                                <li>{langCheck('102202APP-000072', 'pages', json)}</li>
                                <li className="isgrandsonRadio">
                                    {this.getTemplateRadio(
                                        langCheck('102202APP-000072', 'pages', json),
                                        'isgrandson',
                                    )}
                                </li>
                            </React.Fragment>
                        )}
                        {/* 设置多页签字段 */}
                        {this.renderTabFields()}
                        {/* 区域隐藏 areahide */}
                        {this.props.isImplement && !checkAreaType.isSearch(selectedArea) ? (
                            <React.Fragment>
                                <li>{langCheck('102202APP-000078', 'pages', json)}</li>
                                <li>{this.getTemplateCheckbox(areastatus(json), 'areahide')}</li>
                            </React.Fragment>
                        ) : null}
                        {selectedArea.areatype && selectedArea.areatype == '0' && (
                            <React.Fragment>
                                {/* /* 国际化处理： 是否关闭快速查询*/}
                                <li>{langCheck('102202APP-000080', 'pages', json)}</li>
                                <li className="isgrandsonRadio">
                                    {this.getTemplateRadio(
                                        langCheck('102202APP-000080', 'pages', json),
                                        'isclosequickquery',
                                    )}
                                </li>
                            </React.Fragment>
                        )}
                        {selectedArea.areatype && selectedArea.areatype === '2' && (
                            <React.Fragment>
                                <li>{langCheck('ZoneSetting-000352', 'pages', json)}</li>
                                {/* /* 国际化处理： 默认分页大小*/}
                                <li>
                                    {this.getTemplateInput(
                                        langCheck('ZoneSetting-000352', 'pages', json),
                                        'pagesize',
                                        5000
                                    )}
                                </li>
                            </React.Fragment>
                        )}
                    </ul>
                </TabPane>
            </Tabs>
        );
    }
}
SetTemplateRight.PropTypes = {};
export default connect(
    state => ({
        areaList: state.zoneSettingData.areaList,
        selectedArea: state.zoneSettingData.selectedArea,
        validate: state.zoneSettingData.validate,
        isImplement: state.zoneSettingData.isImplement,
        zoneDatas: state.zoneRegisterData.zoneDatas,
    }),
    {
        updateAreaList,
        updateSelectArea,
    },
)(SetTemplateRight);
